const SET_ENROLLMENT_LIST: string = 'SET_ENROLLMENT_LIST';
const SET_ENROLLMENT_HISTORY: string = 'SET_ENROLLMENT_HISTORY';
const SET_ENROLLMENT_DETAILS: string = 'SET_ENROLLMENT_DETAILS';
const SET_ENROLLMENTANDENROLLEE_DETAILS: string = 'SET_ENROLLMENTANDENROLLEE_DETAILS';
const SET_PERMISSION_DETAILS: string = 'SET_PERMISSION_DETAILS';
const SET_SELECTED_ENROLLMENT: string = 'SET_SELECTED_ENROLLMENT';
const SET_REQUEST_RESPONSE: string = 'SET_REQUEST_RESPONSE';

const ENROLLMENT_ACTION_TYPES = {
    SET_ENROLLMENT_LIST,
    SET_ENROLLMENT_HISTORY,
    SET_ENROLLMENT_DETAILS,
    SET_ENROLLMENTANDENROLLEE_DETAILS,
    SET_PERMISSION_DETAILS,
    SET_SELECTED_ENROLLMENT,
    SET_REQUEST_RESPONSE,
};

export default ENROLLMENT_ACTION_TYPES;
